// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1RCzg","range":"MonthRangeSwitch_range__89w5d","disabled":"MonthRangeSwitch_disabled__2zkNk"};